(function () {
  'use strict';

  function init() {
    initMobileNav();
    initProductAccordions();
    initFaqAccordion();
    initQuantitySelectors();
    initProductGallery();
    initLightbox();
    initVariantPills();
    initScrollReveal();
    initStickyHeader();
    initSearchOverlay();
    initCartQuantityButtons();
    initHeroSlideshow();
  }

  /* ── Mobile nav ── */
  function initMobileNav() {
    var toggle = document.querySelector('.site-header__menu-toggle');
    var nav = document.getElementById('mobile-nav');
    var overlay = document.querySelector('.mobile-nav-overlay');
    var close = document.querySelector('.mobile-nav__close');
    if (!toggle || !nav) return;

    function open() {
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function shut() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    if (overlay) overlay.addEventListener('click', shut);
  }

  /* ── Search overlay ── */
  function initSearchOverlay() {
    var btn = document.querySelector('[data-search-toggle]');
    var overlay = document.querySelector('.search-overlay');
    var closeBtn = document.querySelector('[data-search-close]');
    var input = overlay ? overlay.querySelector('.search-overlay__input') : null;
    if (!btn || !overlay) return;

    function open() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      if (input) {
        setTimeout(function () { input.focus(); }, 100);
      }
    }
    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      if (input) input.value = '';
    }

    btn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        close();
      }
    });

    document.addEventListener('click', function (e) {
      if (overlay.classList.contains('is-open') &&
          !overlay.contains(e.target) &&
          !btn.contains(e.target)) {
        close();
      }
    });
  }

  /* ── FAQ accordion (hidden attribute) ── */
  function initFaqAccordion() {
    document.querySelectorAll('.faq-accordion__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-accordion__item');
        var panel = item.querySelector('.faq-accordion__panel');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        item.closest('.faq-accordion').querySelectorAll('.faq-accordion__item').forEach(function (other) {
          if (other !== item) {
            var otherBtn = other.querySelector('.faq-accordion__trigger');
            var otherPanel = other.querySelector('.faq-accordion__panel');
            if (otherBtn.getAttribute('aria-expanded') === 'true') {
              otherBtn.setAttribute('aria-expanded', 'false');
              otherPanel.setAttribute('hidden', '');
            }
          }
        });

        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          panel.setAttribute('hidden', '');
        } else {
          btn.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('hidden');
        }
      });
    });
  }

  /* ── Product accordions (hidden attr) ── */
  function initProductAccordions() {
    document.querySelectorAll('.accordion__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.accordion__item');
        var panel = item.querySelector('.accordion__panel');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          panel.setAttribute('hidden', '');
        } else {
          btn.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('hidden');
        }
      });
    });
  }

  /* ── Quantity selectors ── */
  function initQuantitySelectors() {
    document.querySelectorAll('.qty-selector').forEach(function (sel) {
      if (sel.closest('.cart-item__qty')) return; /* cart has its own handler */
      var input = sel.querySelector('.qty-selector__input');
      if (!input) return;
      sel.querySelectorAll('.qty-selector__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          var min = parseInt(input.min, 10) || 1;
          if (btn.dataset.action === 'increment') val++;
          if (btn.dataset.action === 'decrement' && val > min) val--;
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ── Cart quantity buttons ── */
  function initCartQuantityButtons() {
    document.querySelectorAll('.cart-item__qty .qty-selector__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sel = btn.closest('.qty-selector');
        var input = sel.querySelector('.qty-selector__input');
        var val = parseInt(input.value, 10) || 1;
        if (btn.dataset.action === 'increment') val++;
        if (btn.dataset.action === 'decrement' && val > 0) val--;
        input.value = val;
      });
    });
  }

  /* ── Product gallery carousel ── */
  function initProductGallery() {
    var carousel = document.querySelector('[data-gallery-carousel]');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('[data-gallery-slide]');
    var dots = document.querySelectorAll('[data-gallery-dot]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');
    var current = 0;
    var total = slides.length;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      slides[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.galleryDot, 10)); });
    });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { goTo(parseInt(thumb.dataset.galleryThumb, 10)); });
    });

    var touchStartX = 0;
    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    var scrollTick = false;
    carousel.addEventListener('scroll', function () {
      if (!scrollTick) {
        requestAnimationFrame(function () {
          var scrollLeft = carousel.scrollLeft;
          var slideWidth = carousel.offsetWidth;
          var newIndex = Math.round(scrollLeft / slideWidth);
          if (newIndex !== current && newIndex >= 0 && newIndex < total) {
            current = newIndex;
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
            thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
          }
          scrollTick = false;
        });
        scrollTick = true;
      }
    }, { passive: true });
  }

  /* ── Lightbox ── */
  function initLightbox() {
    var lightbox = document.querySelector('[data-lightbox]');
    if (!lightbox) return;

    var img = lightbox.querySelector('[data-lightbox-img]');
    var counter = lightbox.querySelector('[data-lightbox-counter]');
    var closeBtns = lightbox.querySelectorAll('[data-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');
    var images = [];
    var currentIdx = 0;

    document.querySelectorAll('[data-gallery-slide], .product-gallery__single').forEach(function (slide) {
      if (slide.dataset.full) images.push(slide.dataset.full);
    });

    function open(index) {
      currentIdx = index;
      show();
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    function preloadAdjacent() {
      if (images.length < 2) return;
      [1, -1].forEach(function (offset) {
        var idx = (currentIdx + offset + images.length) % images.length;
        var link = document.createElement('link');
        link.rel = 'prefetch';
        link.as = 'image';
        link.href = images[idx];
        document.head.appendChild(link);
      });
    }
    function show() {
      if (!images.length) return;
      img.src = images[currentIdx];
      if (counter) counter.textContent = (currentIdx + 1) + ' / ' + images.length;
      preloadAdjacent();
    }
    function prev() { currentIdx = (currentIdx - 1 + images.length) % images.length; show(); }
    function next() { currentIdx = (currentIdx + 1) % images.length; show(); }

    document.querySelectorAll('[data-gallery-slide], .product-gallery__single').forEach(function (slide, i) {
      slide.addEventListener('click', function () { open(i); });
    });

    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    var lbTouchX = 0;
    lightbox.addEventListener('touchstart', function (e) {
      lbTouchX = e.changedTouches[0].screenX;
    }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      var diff = lbTouchX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) { diff > 0 ? next() : prev(); }
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    });
  }

  /* ── Variant pill selector ── */
  function initVariantPills() {
    var radios = document.querySelectorAll('.variant-selector__option input[type="radio"]');
    if (!radios.length) return;

    var variantIdInput = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var productJson = null;

    try {
      var scriptEl = document.querySelector('[type="application/ld+json"]');
      if (scriptEl) productJson = JSON.parse(scriptEl.textContent);
    } catch (e) {}

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        // For single-option products, handled by Shopify form
      });
    });
  }

  /* ── Scroll reveal animation ── */
  function initScrollReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ── Sticky header shadow ── */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var scrolled = false;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var isScrolled = window.scrollY > 10;
          if (isScrolled !== scrolled) {
            scrolled = isScrolled;
            header.classList.toggle('is-scrolled', scrolled);
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── Hero slideshow ── */
  function initHeroSlideshow() {
    var slideshow = document.querySelector('[data-hero-slideshow]');
    if (!slideshow) return;

    var slides = slideshow.querySelectorAll('.home-hero__slide');
    if (slides.length < 2) return;

    var current = 0;
    var hero = slideshow.closest('.home-hero');
    var duration = parseInt(hero ? hero.dataset.slideDuration : 5, 10) || 5;

    setInterval(function () {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, duration * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
